import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default ({
  title,
  ...extra
}) => /*#__PURE__*/_jsxs("svg", {
  height: "50",
  width: "50",
  viewBox: "0 0 50 50",
  ...extra,
  children: [title, /*#__PURE__*/_jsx("path", {
    d: "M25,0 C40.448,0 50,12.958 50,25 C50,38.77 38.77,50 25,50 C11.23,50 0,38.77 0,25 C0,11.23 11.23,0 25,0 Z M25,3 C12.88,3 3,12.88 3,25 C3,37.12 12.88,47 25,47 C37.12,47 47,37.12 47,25 C47,14.402 38.594,3 25,3 Z M26.778,21.798 L26.778,34.654 L23.222,34.654 L23.222,21.798 L26.778,21.798 Z M26.778,15.344 L26.778,18.904 L23.222,18.904 L23.222,15.344 L26.778,15.344 Z"
  })]
});